export default __webpack_public_path__ + "e9d24d47b72a871bdcebc0694e2c4f74.svg";